"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Icon from "@/components/ui/AppIcon";
import AppImage from "@/components/ui/AppImage";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { id: "nav_home", label: "Hjem", href: "/homepage" },
    { id: "nav_dashboard", label: "Dashbord", href: "/dashboard" },
    { id: "nav_register", label: "Registrer Kjøretøy", href: "/vehicle-registration" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "py-3" : "py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <nav
          className={`glass border border-slate-200 rounded-2xl px-6 py-3 shadow-soft transition-all duration-300 ${
            scrolled ? "shadow-lg" : ""
          }`}
        >
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link href="/homepage" className="flex items-center gap-3 group">
              <AppImage
                src="/assets/images/FullLogo_Transparent-1770223924492.png"
                alt="Oslo Bil Auto AS Logo"
                width={160}
                height={40}
                className="h-10 w-auto object-contain"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              {navLinks?.map((link) => (
                <Link
                  key={link?.id}
                  href={link?.href}
                  className={`text-sm font-medium transition-colors ${
                    pathname === link?.href
                      ? "text-primary" :"text-muted-foreground hover:text-foreground"
                  }`}
                >
                  {link?.label}
                </Link>
              ))}
            </div>

            {/* CTA Button */}
            <div className="hidden lg:flex items-center gap-4">
              <Link
                href="/login"
                className="px-4 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors"
              >
                Logg inn
              </Link>
              <Link
                href="/register"
                className="px-6 py-2.5 bg-primary text-primary-foreground rounded-xl font-medium hover:bg-primary/90 transition-all shadow-md hover:shadow-lg"
              >
                Registrer deg
              </Link>
            </div>

            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden p-2 text-foreground hover:text-primary transition-colors"
              aria-label="Toggle menu"
            >
              <Icon
                name={mobileMenuOpen ? "XMarkIcon" : "Bars3Icon"}
                size={24}
              />
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="lg:hidden mt-6 pt-6 border-t border-slate-200 animate-fade-in">
              <div className="flex flex-col gap-4">
                {navLinks?.map((link) => (
                  <Link
                    key={link?.id}
                    href={link?.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`text-base font-medium py-2 transition-colors ${
                      pathname === link?.href
                        ? "text-primary" :"text-muted-foreground hover:text-foreground"
                    }`}
                  >
                    {link?.label}
                  </Link>
                ))}
                <div className="mt-4 flex flex-col gap-3">
                  <Link
                    href="/login"
                    onClick={() => setMobileMenuOpen(false)}
                    className="px-6 py-3 bg-slate-100 text-foreground rounded-xl font-medium text-center hover:bg-slate-200 transition-all"
                  >
                    Logg inn
                  </Link>
                  <Link
                    href="/register"
                    onClick={() => setMobileMenuOpen(false)}
                    className="px-6 py-3 bg-primary text-primary-foreground rounded-xl font-medium text-center hover:bg-primary/90 transition-all shadow-md"
                  >
                    Registrer deg
                  </Link>
                </div>
              </div>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}